import { Link } from 'react-router-dom';
import type { IFloatingMenuProps } from './IFloatingMenuProps';
import { MenuOverlay } from './MenuOverlay';
import { MenuRowView } from './MenuRowView';
import { useMenuKeys } from './useMenuKeys';

/**
 * Випадне меню групи модулів або закріплених модулів (прототип v4 G:L375–410): 320px, max-height min(70vh, 560px), радіус 12px, тінь меню;
 * шапка-посилання на огляд напряму («назва · N модулів · відкрити огляд напряму →», наведення — --accent-soft), прокрутний список рядків,
 * нижня кнопка «Показати в „Усі модулі“ →» на тлі --surface2.
 * Клавіатура — ↑ ↓ Home End Esc (useMenuKeys); клік поза меню закриває його.
 */
export function FloatingMenu({ label, heading, rows, empty, footer, x, y, onClose, trigger }: IFloatingMenuProps) {
  const { menu, onKeyDown } = useMenuKeys<HTMLDivElement>(true, onClose, trigger);
  return (
    <>
      <MenuOverlay onClose={onClose} />
      <div ref={menu} role="menu" aria-label={label} className="tb-fmenu" style={{ left: x, top: y }} onKeyDown={onKeyDown}>
        {heading && !heading.to && (
          <div className="tb-fmenu__head">
            <strong className="tb-fmenu__title">{heading.title}</strong>
            <span className="tb-fmenu__sub">{heading.sub}</span>
          </div>
        )}
        {heading?.to && (
          <Link role="menuitem" className="tb-fmenu__head is-link" to={heading.to} title={heading.hint} onClick={onClose}>
            <span className="tb-fmenu__titles"><strong className="tb-fmenu__title">{heading.title}</strong><span className="tb-fmenu__sub">{heading.sub}</span></span>
            <span className="tb-fmenu__arrow" aria-hidden="true">→</span>
          </Link>
        )}
        <div className="tb-fmenu__list">
          {rows.map((row) => <MenuRowView key={row.key} row={row} onClose={onClose} />)}
          {!rows.some((r) => r.kind === 'item') && empty && <div className="tb-fmenu__empty">{empty}</div>}
        </div>
        <Link role="menuitem" className="tb-fmenu__foot" to={footer.to} onClick={onClose}>{footer.label}</Link>
      </div>
    </>
  );
}
